import {
  clearSrDocumentPropertyAction,
  deleteSrDocumentProperty,
} from 'actions/srDocuments/srDocumentPropertyActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentPropertyDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentPropertyAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentProperty(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this site readiness document property?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentPropertyDelete
